import { Alert, Box, Center, Drawer, Loader } from '@mantine/core';

import { IconAlertCircle } from '@tabler/icons-react';

import { DetailDrawerHeaderView } from '../common/molecules/DetailDrawerHeader';
import { EmptyStateView } from '../empty-state';
import type { DrawerTemplateViewProps } from './DrawerTemplate.types';

export function DrawerTemplateView({
  opened,
  onClose,
  position = 'right',
  closeOnClickOutside,
  icon,
  iconColor = 'brand',
  title,
  menu,
  size = 'md',
  loading = false,
  error,
  empty,
  children,
  footer,
}: DrawerTemplateViewProps) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position={position}
      size={size}
      closeOnClickOutside={closeOnClickOutside}
      padding={0}
      withCloseButton={false}
      styles={{
        body: {
          padding: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DetailDrawerHeaderView icon={icon} iconColor={iconColor} title={title} menu={menu} onClose={onClose} />

      <Box style={{ flex: 1, overflowY: 'auto', minHeight: 0 }} p="md">
        {loading ? (
          <Center h="100%">
            <Loader />
          </Center>
        ) : error ? (
          <Alert
            color="red"
            variant="light"
            icon={<IconAlertCircle size={18} />}
            title="Der opstod en fejl"
          >
            {error}
          </Alert>
        ) : empty ? (
          <EmptyStateView variant="page" {...empty} />
        ) : (
          children
        )}
      </Box>

      {footer && !loading && (
        <Box p="md" style={{ borderTop: '1px solid var(--mantine-color-gray-3)', flexShrink: 0 }}>
          {footer}
        </Box>
      )}
    </Drawer>
  );
}
